import { createApp, configureCompat } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import i18n from '@/libs/i18n'
import { useAppStore } from '@/stores/appStore.js'

// Import third-party plugins and global components
import setupCASL from '@/libs/acl'
import setupToast from '@/libs/toastification'
import vSelect from '@/libs/vue-select'
//import { VueSelect } from "vue-select";

import axiosIns from '@/libs/axios';

// Import style
import '@resources/scss/core.scss'
import '@resources/assets/scss/style.scss'
import 'vue-select/dist/vue-select.css';
//import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'

// 3rd party components
import VueMask from 'v-mask'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import CountryFlag from 'vue-country-flag-next'

import PortalVue from 'portal-vue'

// Initialize Pinia
const pinia = createPinia()

configureCompat({
  // BootstrapVue components can carry nested component state that recurses
  // with compat deep data merge behavior.
  OPTIONS_DATA_MERGE: false,
})

// Create Vue app
const app = createApp(App)

// Register Pinia before any other plugins or components
app.use(pinia)

// Install other plugins
app.use(router)
app.use(i18n)
app.use(VueMask)
app.use(PortalVue)

const appStore = useAppStore(pinia)
const responsiveModalKeys = ['modalScrollable', 'modalCentered', 'modalClass']

const hasResponsiveModalState = vm => responsiveModalKeys
  .every(key => key in vm)

const syncResponsiveModalState = vm => {
  if (!hasResponsiveModalState(vm)) return

  const currentWidth = appStore.windowWidth || (typeof window !== 'undefined' ? window.innerWidth : 801)
  const isMobile = currentWidth <= 800

  vm.modalScrollable = isMobile
  vm.modalCentered = !isMobile
  vm.modalClass = isMobile ? 'modal-fullscreen' : ''
}

app.mixin({
  mounted() {
    if (!hasResponsiveModalState(this)) return

    syncResponsiveModalState(this)
    this.$watch(
      () => appStore.windowWidth,
      () => syncResponsiveModalState(this),
    )
  },
})

app.config.errorHandler = (error, vm, info) => {
  if (error.name === 'ChunkLoadError') {
    // Handle the error gracefully
    console.log('Chunk loading failed. Retrying...');
    window.location.reload();
  }
};

app.component('vue-cookie-accept-decline', VueCookieAcceptDecline)
/*app.use(Flag, {
  name: 'Flag'
})*/
app.component('country-flag', CountryFlag)

// Register global components
app.component('v-select', vSelect)

// Setup additional plugins
setupCASL(app)
setupToast(app)

// Provide the axios instance to the app so it can be used globally as this.$http
app.config.globalProperties.$http = axiosIns

// Set up Echo (adjust to Vue 3 if necessary)
/*import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')
const echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  wsHost: 'app.yournutri.ch',
  wsPort: 443,
  forceTLS: true,
  auth: {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
    }
  }
})*/

/*const echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  wsHost: 'app.yournutri.ch',
  wsPort: 443,
  wssPort: 443,
  forceTLS: true,
  enabledTransports: ['ws','wss'],
  auth: { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } }
});*/

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import createBroadcastAuthorizer from '@/libs/broadcastAuthorizer'

window.Pusher = Pusher

if (process.env.MIX_APP_DEBUG === 'true') {
  Pusher.logToConsole = true
}

const echoOptions = {
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,

  // 👇 pusher-js v8 veut "host" ou "cluster" ; on donne le host = domaine
  host:   process.env.MIX_PUSHER_HOST || window.location.hostname,
  wsHost: process.env.MIX_PUSHER_HOST || window.location.hostname,

  // 👇 IMPORTANT: on passe par Nginx (80/443), pas par 6001/6002 côté navigateur
  wsPort: 80,
  wssPort: 443,
  forceTLS: true,

  enabledTransports: ['ws', 'wss'],
  disableStats: true,
  cluster: 'mt1',
  authEndpoint: '/broadcasting/auth',
  authorizer: createBroadcastAuthorizer(axiosIns),
}


/*const echoOptions = {
  broadcaster: 'pusher',
  host: process.env.MIX_PUSHER_HOST || window.location.hostname, // <-- NEW
  key: process.env.MIX_PUSHER_APP_KEY, // requis même avec Soketi
  wsHost: process.env.MIX_PUSHER_HOST || window.location.hostname,
  wsPort: Number(process.env.MIX_PUSHER_PORT || 6001),
  wssPort: Number(process.env.MIX_PUSHER_PORT || 6001),
  forceTLS: (process.env.MIX_PUSHER_SCHEME || 'http') === 'https',
  enabledTransports: ['ws', 'wss'],
  disableStats: true,
  cluster: 'mt1',
  // Auth privé / presence
  authEndpoint: '/broadcasting/auth',
  authorizer: (channel) => ({
    authorize: (socketId, callback) => {
      axiosIns.post('/broadcasting/auth', {
        socket_id: socketId,
        channel_name: channel.name,
      })
      .then(res => callback(false, res.data))
      .catch(err => {
        console.error('Broadcast auth failed:', err?.response?.status, err?.response?.data)
        callback(true, err)
      })
    }
  }),
  // (optionnel) si tu utilises auth Bearer/cookies custom:
  // authorizer: (channel, options) => ({
  //   authorize: (socketId, callback) => {
  //     axios.post('/broadcasting/auth', { socket_id: socketId, channel_name: channel.name })
  //          .then(res => callback(false, res.data))
  //          .catch(err => callback(true, err));
  //   }
  // }),
}*/

export const echo = new Echo(echoOptions)
window.Echo = echo

app.config.globalProperties.$echo = echo

import dayjs from '@/libs/dayjs'

app.config.globalProperties.$dayjs = dayjs

/*import Vue3TouchEvents from 'vue3-touch-events';

app.use(Vue3TouchEvents, {
  disableClick: false, 
});*/

import { registerAllIcons } from '@core/icons'

registerAllIcons(app)

// Mount app
app.mount('#app')
